<app-pre-loader *ngIf="IsLoadingResults"></app-pre-loader>

<div class="navbar navbar-default navpage-header" Id="div1" >
    <div class="container-fluid" >
      <div class="navbar-header" nav-banner-logo="">
        <a class="navbar-brand">
        <img id="mainBannerImage16" id="img1"
         src="assets/img/EY_Logo.png" aria-hidden="true">
        </a>
          <span class="banner-text h4" id="SpanId1">InTaxGTC</span>
      </div>
    </div>
    </div>
  <div class="content-wrapper">
      <div class="container">
          <div class="container-fluid" id="divid2">
              <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 logout-body">
                      <div class="row" id="divid3">
                          <div id="divid4" class="col-md-2">
                              <i id="infoId1" class="pi pi-exclamation-triangle"></i>
                          </div>
                          <div id="divid5" class="col-md-10 text-left">
                              <p id="p1">{{ErrorMessage}}</p>
                              <h5>You have been logged out from this application.</h5>
                              <span id="Idspan1"><a id="Anchor1" (click)="Login()">Please Click Here to Re-login</a> </span>
                          </div>
                      </div>
                  </div>
              </div>
              <!-- <mat-card style="margin: 10px; padding: 10px;">
                <div class="row">
                    <div class="mb-3 col-md-5">
                        <label>Test Login </label>
                        <input class="form-control col-md-8" id="message"
                         type="text"
                         name="message">
                  <button class="btn-primary1" (click)="LoginValue()" 
                  type="button"
                  
                    mat-stroked-button>
                    Login With Email
                  </button>
                  
                    </div>
                </div>
                <div class="row" style="margin: 5px; padding: 10px;">
                    <label style="color: red; font-size: 15px;">Note :This is the test login for testers ,
                         Test the application with different mail id's with different role's</label>

                </div>
            </mat-card> -->
          </div>
      </div>
  </div>
  